export const EMAIL_PROVIDERS = {
    GMAIL: {
        name: 'Gmail',
        icon: <img src="/images/gmail.svg" alt="loader" width={48} height={48} />,
    },
    // OUTLOOK_CALENDAR: {
    //     name: 'Outlook Calendar',
    //     icon: <img src="/images/outlook.svg" alt="loader" width={48} height={48} />,
    // },
};
